import axios from "axios";
import { getAuthHeader } from "../utils/authHeader";
import { User } from "../Admin/types";

class UserService {
    private baseUrl: string;

    constructor() {
        this.baseUrl = process.env.REACT_APP_BACKEND_URL!;
    }

    async getAllUsers(): Promise<User[]> {
        try {
            const headers = await getAuthHeader();
            const response = await axios.get(`${this.baseUrl}/admin/users`, {
                headers,
            });

            if (response.status !== 200) {
                throw new Error("Failed to fetch users. Please try again later.");
            }

            return response.data;
        } catch (error: unknown) {
            console.error("Failed to fetch users:", error);
            throw new Error("Failed to fetch users");
        }
    }
}

export const userService = new UserService();